import React, { useEffect, useState } from 'react'
import QRCode from 'react-qr-code';
//COMPONENTS
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../Alerts/ErrorAlert';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import LoadingAlert from '../Alerts/LoadingAlert';
import AlertSmall from '../Alerts/AlertSmall';

//APIS
import { MailFetchAPI } from '../../api/Mail';
import { WhatsappFetchAPI } from '../../api/Whatsapp';


function ModalSendLinkPayment({ sendLinkPayment, setSendLinkPayment, PreOrderDataCallCenter, dataClientSelected, dataOrder, domain, buttonNewOrder }) {

    const [emailSendLink, setEmailSendLink] = useState("");
    const [phoneSendLink, setPhoneSendLink] = useState("");
    const [key, setKey] = useState('phone');
    const [url, setUrl] = useState(``);



    //Send email with payment link to customer
    const sendMailValid = () => {
        let token = localStorage.getItem('x-access-machine-token')
        if (emailSendLink == "" || emailSendLink == undefined || emailSendLink == null) {
            ErrorAlert("", "Ingrese un correo valido", "error")
            return
        } else {


            //let url = `https://${domain}/cart/order/${code}`
            //let url = `https://1h8p3t4t-3002.use2.devtunnels.ms/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`
            //let url = `http://localhost:3002/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`
            let data = {
                "email": emailSendLink,
                "subject": "Link de pago",
                "text": url,
            }

            console.log(data);
            try {
                const response = MailFetchAPI.sendMail(data, token)
                ErrorAlert('', 'Correo enviado con exito', 'success')
            } catch (err) {
                setSendLinkPayment(false)
                ErrorAlert('', err.response.data ? err.response.data.error : "Error al enviar correo", 'error')
                console.log(err)
            }
        }
    }

    const sendMessage = async () => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))
        //let url = `https://${domain}/cart/order/${code}`
        //let url = `https://1h8p3t4t-3002.use2.devtunnels.ms/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`
        let dataClient = {
            "notification_type": "smartpay_notification",
            "branchoffice_id": branchoffice.id,
            "business_id": business.id,
            "phone_to_send": phoneSendLink,
            "header_text": "Link de pago",
            "message_body": [{ "text": "Smartpay" }, { "text": `Link de pago url:  ${url}` }]
        }
        try {
            const response = await WhatsappFetchAPI.sendNotificationWhatsapp(dataClient, token)
            ErrorAlert("Exito", "Mensaje enviado correctamente", "success")


        } catch (err) {
            ErrorAlert("Opps..", "No se pudo enviar el mensaje", "error")
            console.log(err);
        }
    }

    const updatePage = () => {
        window.location.reload()
    }



    useEffect(() => {
        if (dataClientSelected != null && dataClientSelected.email != "") {
            setEmailSendLink(dataClientSelected.email);
        } else {
            setEmailSendLink("");
        }

        if (dataClientSelected != null && dataClientSelected.phone != "") {
            setPhoneSendLink(dataClientSelected.phone);
        } else {
            setPhoneSendLink("");
        }

        if (PreOrderDataCallCenter != null && PreOrderDataCallCenter.code != "" && PreOrderDataCallCenter._id != "") {
            setUrl(`https://${domain}/cart/order/${PreOrderDataCallCenter.code}/${PreOrderDataCallCenter._id}`);
        } else {
            setUrl("");
        }


    }, [dataOrder, dataClientSelected, PreOrderDataCallCenter])

    return (
        <>

            <Modal
                show={sendLinkPayment}
                size="md"
                className='bg-blur-sp'
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Body>
                    <div className='row align-items-center'>
                        <div className="d-flex justify-content-center align-items-lg-center">
                            <div className="border-0 rounded-4">
                                <section className="form-signin-sp bg-white">
                                    <div className="d-flex justify-content-center border-bottom-0">
                                        <h2 className="modal-title fw-bold fs-5">
                                            <i class="uil uil-shopping-bag"></i> Crear link de pago
                                        </h2>
                                    </div>

                                    <div>
                                        <div className='d-flex justify-content-center align-items-lg-center'><span className='p-0  text-primary fw-bold'>Envio de link de pago </span></div>
                                        <div className='d-flex justify-content-center align-items-lg-center m-2'>
                                            <QRCode value={url}
                                                size={150}
                                                bgColor="#ffffff" // Color de fondo
                                                fgColor="#000000" // Color del texto
                                                level="H" />
                                        </div>
                                        <div
                                            style={{
                                                wordBreak: 'break-all',
                                                overflowWrap: 'break-word',
                                                maxWidth: 300,
                                                margin: '0 auto'
                                            }}
                                        >


                                            <div className='d-flex justify-content-center align-items-lg-center m-2'><span className='p-0  text-primary fw-bold'>o comparte el link</span></div>

                                            <div className='d-flex justify-content-center m-2'>
                                                <button
                                                    className="btn btn-primary m-1"
                                                    onClick={() => window.open(url, '_blank')}
                                                >
                                                    <i className="uil uil-external-link-alt"></i> Ir a página
                                                </button>
                                                <button
                                                    className="btn btn-outline-secondary m-1"
                                                    onClick={() => (AlertSmall("Link copiado con exito", "success"), navigator.clipboard.writeText(url))}
                                                >
                                                    <i className="uil uil-copy"></i> Copiar Link
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='pb-4'>
                                        <Tabs
                                            id="controlled-tab-example"
                                            activeKey={key}
                                            onSelect={(k) => setKey(k)}
                                            className="mt-3"
                                        >
                                            <Tab eventKey="email" title={<i class="uil uil-envelope-upload"> Email</i>}>


                                                <label className="form-label fw-bold text-black mt-2">
                                                    <i class="uil uil-envelope-upload"></i> Ingrese el correo
                                                </label>
                                                <input type="text"
                                                    className="form-control rounded-3 border-1 text-muted"
                                                    placeholder="email@example.com"
                                                    value={emailSendLink}
                                                    onChange={(e) => setEmailSendLink(e.target.value)} />

                                            </Tab>
                                            <Tab eventKey="phone" title={<i className="uil uil-whatsapp"> Whatsapp</i>}>
                                                <label className="form-label fw-bold text-black mt-2">
                                                    <i className="uil uil-whatsapp"></i> Ingrese el numero de telefono
                                                </label>
                                                <input type="text"
                                                    className="form-control rounded-3 border-1 text-muted"
                                                    placeholder="+507 6000-0000"
                                                    value={phoneSendLink}
                                                    onChange={(e) => setPhoneSendLink(e.target.value)} />

                                            </Tab>
                                        </Tabs>

                                        <div className="d-flex justify-content-between mt-4">

                                            {buttonNewOrder == true ? <><button className="btn bg-primary-subtle text-primary  border-0 fw-bold m-1" onClick={() => (LoadingAlert(), updatePage())} >
                                                <i class="uil uil-file-plus-alt"></i> Nueva orden
                                            </button></> : <><button className='btn bg-danger-subtle text-danger  border-0 fw-bold m-1'
                                                onClick={() => setSendLinkPayment(false)} >
                                                <i class="uil uil-times-circle"></i>  Cerrar
                                            </button></>}

                                            <button className="btn bg-success-subtle text-success  border-0 fw-bold m-1" onClick={() => { if (key === "email") { sendMailValid() } else { sendMessage() } }} >
                                                <i class="uil uil-envelope-send"></i> Enviar Link de pago
                                            </button>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


        </>
    )
}

export default ModalSendLinkPayment